export default {"src":"https://assets.madeeasy.in/non-prod/_next/static/media/order-history.8de3c4eb.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};